import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  setErrorText: ['payload'],
  setSuccessText: ['payload'],
  applyCouponCodeRequest: ['payload'],
}, { prefix: '[COUPON CODE] ' });
